import React from 'react';

// Chakra imports
import { Flex, Image, Text, useColorModeValue } from '@chakra-ui/react';
// Custom components
import { HSeparator } from '../../separator/Separator';
import Logo from '../../../assets/img/layout/logo.png';
import PropTypes from 'prop-types';

export function SidebarBrand({ isCompact = false, isCollapsed = false }) {
  //   Chakra color mode
  let logoColor = useColorModeValue('navy.700', 'white');
  const imageSize = isCollapsed ? '48px' : isCompact ? '110px' : '80px';

  return (
    <Flex align={isCollapsed ? 'center' : 'flex-start'} direction="column" w="100%">
      <Flex
        align="center"
        direction={isCollapsed ? 'column' : 'row'}
        gap={isCollapsed ? 2 : 3}
      >
        <Image src={Logo} boxSize={imageSize} my={isCollapsed ? '16px' : '24px'} ml="-20px" />
        <Text color={logoColor} fontSize="2xl" fontWeight="bold" display={isCollapsed ? 'none' : 'block'} ml ="-15px">
          LogiLift
        </Text>
      </Flex>
      <HSeparator mb="20px" />
    </Flex>
  );
}

SidebarBrand.propTypes = {
  isCompact: PropTypes.bool,
  isCollapsed: PropTypes.bool,
};

export default SidebarBrand;
